<template>
	<q-layout view="hHh lpR fFf" id="pageLayout">
		<q-header bordered class="text-primary header" id="pageHeaderContainer">
			<q-toolbar class="q-px-md q-mx-sm" id="pageHeaderToolbar">
				<div class="header-logo-container" :class="{'disable-events': portal.disableHomeButtonClick }" id="logoContainer" @click="refresh">
					<img src="./assets/logo.png" class="header-logo" id="logo" />
				</div>
				<q-toolbar-title :class="{'disable-events': portal.disableHomeButtonClick }" class="header-title" id="headerTitle">
					<span id="headerTitleContent" class="header-title-content" @click="refresh">{{ $t("portal_visitorPortal") }}</span>
				</q-toolbar-title>
				<q-select
					v-if="locales.length > 1"
					v-model="selectedLocale"
					:options="locales.map(l => ({ label: l.toUpperCase(), value: l }))"
					:display-value="selectedLocale?.toUpperCase()"
					id="languageSelect"
					aria-label="Select language"
					dense
					outlined
					emit-value
					map-options
					options-dense
					behavior="menu"
					popup-content-class="language-select-popup"
				>
					<template v-slot:prepend>
						<q-icon name="language" size="18px" color="primary" aria-hidden="true" />
					</template>
				</q-select>
				<q-btn
					@click="$q.dark.toggle"
					flat
					round
					dense
					:color="$q.dark.isActive ? 'white' : 'black'"
					:icon="$q.dark.isActive ? 'light_mode' : 'dark_mode'"
					id="darkMode"
				/>
			</q-toolbar>
		</q-header>

		<q-page-container
			v-if="portal.isAppReady"
			:class="portal.navPageConfig[portal.currentNavIndex].pageClass"
		>
			<q-page
				class="flex q-layout-padding flex justify-center items-start row"
				:class="{ 'content-center': portal.currentNavIndex === 1 }"
				id="pageContentContainer"
			>
				<div
					class="col-md-8 col-sm-10 col-xs-12 q-pa-md"
					id="pageComponentContainer"
				>
					<component
						:is="portal.navPageConfig[portal.currentNavIndex].component"
						v-bind="portal.navPageConfig[portal.currentNavIndex]"
					></component>
				</div>
			</q-page>
		</q-page-container>

		<q-footer bordered class="text-primary q-pa-sm footer" id="pageFooter">
			<q-toolbar id="pageFooterToolbar">
				<NavBar @next="next" @back="back" @skip="skip" />
			</q-toolbar>
			
		</q-footer>
		<q-footer bordered class="text-primary q-pa-sm footer" id="poweredByRcFooter">
			<div id="poweredByRcContent" @click="goToRightCrowd">
				<span>Powered by RightCrowd</span>
			</div>			
		</q-footer>
	</q-layout>

	<q-dialog v-model="portal.shouldOpenDialog" id="dialogBox">
		<q-card id="card">
			<q-card-section class="bg-negative text-white" id="dialogHeader">
				<div class="text-h6" id="dialogHeaderTitle">
					<q-icon name="error_outline" size="25px" id="dialogHeaderIcon" />
					{{ $t(portal.dialogTitle) }}
				</div>
			</q-card-section>

			<q-card-section id="dialogContent">
				{{ $t(portal.dialogMsg) }}
			</q-card-section>

			<q-card-actions align="right" id="dialogActionsContainer">
				<q-btn
					flat
					:label="$t('portal_okBtn')"
					color="primary"
					id="dialogActionButton"
					v-close-popup
				/>
			</q-card-actions>
		</q-card>
	</q-dialog>
</template>

<script lang="ts" src="./App.ts"></script>
<style lang="less" src="./styles/styles.less"></style>